(() => {
  if (window.PuzzlePupPdpDrawers) return;
  let opener = null;
  let bodyLock = null;
  let uniformHome = null;

  const drawers = () => [...document.querySelectorAll('[data-pp-info-drawer], [data-pp-purchase-drawer]')];
  const focusable = root => [...root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(item => !item.hidden);
  const track = (eventName, payload) => window.PuzzlePupAnalytics?.track(eventName, payload);

  function lockBody() {
    if (bodyLock) return;
    const scrollY = window.scrollY;
    const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    const body = document.body;
    bodyLock = {
      scrollY,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight
    };
    const currentPadding = Number.parseFloat(getComputedStyle(body).paddingRight) || 0;
    body.style.position = 'fixed';
    body.style.top = '-' + String(scrollY) + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (scrollbar) body.style.paddingRight = String(currentPadding + scrollbar) + 'px';
  }

  function unlockBody() {
    if (!bodyLock) return;
    const saved = bodyLock;
    bodyLock = null;
    const body = document.body;
    body.style.position = saved.position;
    body.style.top = saved.top;
    body.style.left = saved.left;
    body.style.right = saved.right;
    body.style.width = saved.width;
    body.style.overflow = saved.overflow;
    body.style.paddingRight = saved.paddingRight;
    window.scrollTo(0, saved.scrollY);
  }

  function close(drawer, restore = true) {
    if (!drawer || drawer.hidden) return;
    const isInfo = drawer.hasAttribute('data-pp-info-drawer');
    const activeTitle = drawer.querySelector('[data-pp-info-title]')?.textContent?.trim();
    const activeTarget = drawer.dataset.ppActiveTarget;
    const uniform = drawer.querySelector('[data-pp-uniform]');
    if (uniform && uniformHome) { uniformHome.replaceWith(uniform); uniformHome = null; }
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    opener?.setAttribute?.('aria-expanded', 'false');
    document.body.classList.remove('pp-v3-drawer-open');
    if (!drawers().some(item => !item.hidden)) unlockBody();
    document.dispatchEvent(new CustomEvent('pp:drawer-state'));
    if (isInfo) track('pp_info_drawer_close', { section_id: activeTarget, drawer_title: activeTitle });
    delete drawer.dataset.ppActiveTarget;
    if (restore) opener?.focus();
  }

  function open(drawer, trigger) {
    if (!drawer) return;
    drawers().forEach(item => { if (item !== drawer) close(item, false); });
    opener = trigger || document.activeElement;
    opener?.setAttribute?.('aria-expanded', 'true');
    lockBody();
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pp-v3-drawer-open');
    document.dispatchEvent(new CustomEvent('pp:drawer-state'));
    if (drawer.hasAttribute('data-pp-info-drawer')) {
      track('pp_info_drawer_open', {
        section_id: drawer.dataset.ppActiveTarget,
        drawer_title: drawer.querySelector('[data-pp-info-title]')?.textContent?.trim()
      });
    } else {
      track('pp_purchase_drawer_open', { trigger_location: trigger?.dataset.ppOpenPurchase !== undefined ? 'sticky_buy' : 'pdp' });
    }
    requestAnimationFrame(() => focusable(drawer)[0]?.focus());
  }

  function openInfo(trigger) {
    const target = document.getElementById(trigger.dataset.ppInfoTarget);
    const drawer = document.querySelector('[data-pp-info-drawer]');
    if (!target || !drawer) return;
    const title = target.dataset.ppInfoTitle || target.querySelector('h2')?.textContent || trigger.textContent;
    const source = target.matches('.pp-section')
      ? (target.querySelector(':scope > .pp-container') || target)
      : target;
    const clone = source.cloneNode(true);
    clone.classList.add('pp-v3-drawer__source');
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
    clone.querySelectorAll('[data-pp-info-section]').forEach(node => node.removeAttribute('data-pp-info-section'));
    clone.querySelectorAll('input,select,textarea').forEach(control => {
      control.disabled = true;
      control.removeAttribute('name');
    });
    clone.querySelectorAll('button[type="submit"]').forEach(button => button.remove());
    drawer.querySelector('[data-pp-info-title]').textContent = title;
    drawer.dataset.ppActiveTarget = trigger.dataset.ppInfoTarget;
    const content = drawer.querySelector('[data-pp-info-content]');
    content.replaceChildren(clone);
    open(drawer, trigger);
  }

  function buildPurchaseChoices(drawer) {
    const choiceRoot = drawer?.querySelector('[data-pp-drawer-choices]');
    const uniform = document.querySelector('[data-pp-v3-pdp] [data-pp-uniform], [data-pp-purchase-drawer] [data-pp-uniform]');
    if (choiceRoot && uniform) {
      const submit = drawer.querySelector('[data-pp-drawer-submit]');
      if (submit) submit.hidden = true;
      if (!choiceRoot.contains(uniform)) {
        uniformHome = document.createComment('PuzzlePup purchase selector home');
        uniform.before(uniformHome);
        choiceRoot.replaceChildren(uniform);
      }
      return;
    }
    const form = document.querySelector('[data-pp-canonical-form]');
    if (!choiceRoot || !form) return;
    choiceRoot.replaceChildren();
    form.querySelectorAll('[data-pp-package]').forEach(input => {
      if (input.closest('[hidden]')) return;
      const label = input.closest('label');
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.ppDrawerPackage = input.value;
      button.classList.toggle('is-active', input.checked);
      const name = input.dataset.title || label?.querySelector('b')?.textContent || 'Package';
      const price = label?.querySelector('strong')?.textContent || '';
      button.innerHTML = '<span>' + name + '</span><strong>' + price + '</strong>';
      button.addEventListener('click', () => {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        buildPurchaseChoices(drawer);
      });
      choiceRoot.append(button);
    });
    form.querySelectorAll('[data-pp-purchase-type]').forEach(input => {
      if (input.disabled) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.classList.toggle('is-active', input.checked);
      const name = input.closest('label')?.querySelector('b')?.textContent || input.value;
      button.innerHTML = '<span>' + name + '</span><strong>' + (input.value === 'subscription' ? 'Save' : 'Once') + '</strong>';
      button.addEventListener('click', () => {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        buildPurchaseChoices(drawer);
      });
      choiceRoot.append(button);
    });
  }

  document.addEventListener('click', event => {
    const info = event.target.closest('[data-pp-info-target]');
    if (info) { event.preventDefault(); openInfo(info); return; }
    const purchase = event.target.closest('[data-pp-open-purchase]');
    if (purchase) {
      const drawer = document.querySelector('[data-pp-purchase-drawer]');
      buildPurchaseChoices(drawer);
      open(drawer, purchase);
      return;
    }
    const closeButton = event.target.closest('[data-pp-drawer-close]');
    if (closeButton) { close(closeButton.closest('.pp-v3-drawer')); return; }
    if (event.target.closest('[data-pp-drawer-submit]')) {
      document.querySelector('[data-pp-canonical-form]')?.requestSubmit();
    }
  });

  document.addEventListener('keydown', event => {
    const drawer = drawers().find(item => !item.hidden);
    if (!drawer) return;
    if (event.key === 'Escape') { event.preventDefault(); close(drawer); return; }
    if (event.key !== 'Tab') return;
    const items = focusable(drawer);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('pp:purchase-state', () => {
    const drawer = document.querySelector('[data-pp-purchase-drawer]');
    if (drawer && !drawer.hidden) buildPurchaseChoices(drawer);
  });
  window.PuzzlePupPdpDrawers = Object.freeze({ open, close, buildPurchaseChoices });
})();
